module.exports = __webpack_public_path__ + "img/banner-1.02cf3b9d.jpg";